import { createContext, useContext, useState } from 'react';

// To-Do: this can be exrended in later refactors to reduce prop drilling
type RecipeDetailContext = {
  ingredientsListRef: React.RefObject<HTMLElement | null> | null;
  instructionsRef: React.RefObject<HTMLElement | null> | null;
  updateRecipeDetailRef: (
    node: React.RefObject<HTMLElement | null>,
    component: 'instructions' | 'ingredients',
  ) => void;
};

const initialState: RecipeDetailContext = {
  ingredientsListRef: null,
  instructionsRef: null,
  updateRecipeDetailRef: () => null,
};

const RecipeDetailContext = createContext<RecipeDetailContext>(initialState);

const RecipeDetailContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [ingredientsListRef, setInsgredientsListRef] =
    useState<React.RefObject<HTMLElement | null> | null>(null);
  const [instructionsRef, setInstructionsRef] =
    useState<React.RefObject<HTMLElement | null> | null>(null);

  const updateRecipeDetailRef = (
    newRef: React.RefObject<HTMLElement | null>,
    component: 'instructions' | 'ingredients',
  ) => {
    if (component === 'ingredients') setInsgredientsListRef(newRef);
    if (component === 'instructions') setInstructionsRef(newRef);
  };

  const state = {
    ingredientsListRef,
    instructionsRef,
    updateRecipeDetailRef,
  };

  return (
    <RecipeDetailContext.Provider value={state}>
      {children}
    </RecipeDetailContext.Provider>
  );
};

export default RecipeDetailContextProvider;

export const useRecipeDetails = () => {
  const context = useContext(RecipeDetailContext);
  if (context === undefined) {
    throw new Error(
      'useRecipeDetails must be used within a RecipeDetailContext.Provider',
    );
  }
  return context;
};
